import { Component, Input, OnInit } from '@angular/core';
import { IInitializePasswordRequest } from '../../../../classes/initialize-password';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'create-new-code',
	template: require('./create-new-code.component.html'),
})
export class CreateNewCodeComponent {
	@Input() initRequest: IInitializePasswordRequest;
	@Input() public isLoginBigModalEnabled: boolean = false;
	@Input() isEmailUnlockUser: boolean = false;
	public isRebrading = AppSettings.isRebrading;
	constructor() {}
}
